module.exports = __webpack_public_path__ + "img/back.5d365c70.png";